import { jsx as _jsx } from "react/jsx-runtime";
import { useParams } from 'react-router-dom';
import { MasterMatrixTab } from '../../MasterMatrixTab';
/**
 * Rebrand of the legacy "Master Matrix" tab — same component, "Amendment
 * History" framing inside the V2 SOURCES rail.
 */ export function SourcesHistoryPage() {
    const { id } = useParams();
    if (!id) return null;
    return /*#__PURE__*/ _jsx("div", {
        className: "p-4 sm:p-6 lg:p-8",
        children: /*#__PURE__*/ _jsx(MasterMatrixTab, {
            projectId: id
        })
    });
}
